import { IShadowSitePdrCatalogs } from '../interfaces/shadowSitePdrCatalogs';
import { BillingPeriod } from '../enums/billingPeriod';
import { FiscalUsageType } from '../enums/fiscalUsageType';
import { PdrType } from '../enums/pdrType';
import { WithdrawalClassType } from '../enums/withdrawalClassType';
import { PhaseContract } from '../enums/phaseContract.enum';
import { MarketType } from '../enums/marketType';

export class ShadowSitePdrCatalogs implements IShadowSitePdrCatalogs {
    address: string;
    city: string;
    declaration: string;
    firstName: string;
    fiscalCode: string;
    id: number;
    idCatalog: number;
    isEditable: boolean;
    isNotUnPowerable: number;
    istatCodeCity: string;
    lastName: string;
    numberAddress: string;
    pdrCode: string;
    postalCode: string;
    previousSupplier: string;
    previousVendor: string;
    province: string;
    remicode: string;
    serialNumber: string;
    shortProvince: string;
    smcUsageYear: string;
    startDateExpected: Date;
    usageCategory: string;
    billingPeriod: BillingPeriod;
    codEnerpVendor: string;
    durationContractMonth: number;
    fiscalUsage: FiscalUsageType;
    phaseContractExport: string;
    typeOfPdr: PdrType;
    vat: number;
    vatExemptionCode: string;
    withdrawalClass: WithdrawalClassType;
    codEnerpPreviousSupplier: string;
    lastExportError: string;
    lastExportPhase: PhaseContract;
    adjustment: boolean;
    marketType: MarketType;
    gasMeterReadingDate: Date;
    gasMeterReading: number;
    supplyOfferSize: number;
    supplyOfferResponsible: number;
    isGenerali: boolean;
    enerpStartDate: Date;

    constructor(sp?: IShadowSitePdrCatalogs) {
        if (sp) {
            this.address = sp.address;
            this.city = sp.city;
            this.declaration = sp.declaration;
            this.firstName = sp.firstName;
            this.fiscalCode = sp.fiscalCode;
            this.id = sp.id;
            this.idCatalog = sp.idCatalog;
            this.isNotUnPowerable = sp.isNotUnPowerable;
            this.istatCodeCity = sp.istatCodeCity;
            this.lastName = sp.lastName;
            this.numberAddress = sp.numberAddress;
            this.pdrCode = sp.pdrCode;
            this.postalCode = sp.postalCode;
            this.previousSupplier = sp.previousSupplier;
            this.previousVendor = sp.previousVendor;
            this.province = sp.province;
            this.remicode = sp.remicode;
            this.serialNumber = sp.serialNumber;
            this.shortProvince = sp.shortProvince;
            this.smcUsageYear = sp.smcUsageYear;
            this.startDateExpected = sp.startDateExpected ? new Date(sp.startDateExpected) : null;
            this.usageCategory = sp.usageCategory;
            this.billingPeriod = sp.billingPeriod;
            this.codEnerpVendor = sp.codEnerpVendor;
            this.durationContractMonth = sp.durationContractMonth;
            this.fiscalUsage = sp.fiscalUsage;
            this.phaseContractExport = sp.phaseContractExport;
            this.typeOfPdr = sp.typeOfPdr;
            this.vat = sp.vat;
            this.vatExemptionCode = sp.vatExemptionCode;
            this.withdrawalClass = sp.withdrawalClass;
            this.codEnerpPreviousSupplier = sp.codEnerpPreviousSupplier;
            this.isEditable = sp.isEditable;
            this.lastExportError = sp.lastExportError;
            this.lastExportPhase = sp.lastExportPhase;
            this.adjustment = sp.adjustment;
            this.marketType = sp.marketType;
            this.gasMeterReadingDate = sp.gasMeterReadingDate
                ? new Date(sp.gasMeterReadingDate)
                : null;
            this.gasMeterReading = sp.gasMeterReading;
            this.supplyOfferSize = sp.supplyOfferSize;
            this.supplyOfferResponsible = sp.supplyOfferResponsible;
            this.isGenerali = sp.isGenerali;
            this.enerpStartDate = sp.enerpStartDate;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/shadowSitePdrCatalogs.ts